{{message}}
<div *ngIf="value.length" class="collection-tag__container">
  <span *ngFor="let item of value" class="collection-tag">
    {{item.title.split(' -> ').join(' → ')}}
  </span>
</div>

<div *ngIf="!value.length && !message && activeBtn">
  <button [disabled]="pending" (click)="regenerate()" class="bulk-btn" mat-raised-button style="background-color: #cecece;"><mat-icon>get_app</mat-icon> Get AI Structure</button>
</div>

<div *ngIf="value.length && !message && activeBtn">
  <button (click)="clear()" matTooltip="Clear" mat-icon-button>
    <mat-icon>clear</mat-icon>
  </button>
</div>

<mat-progress-bar *ngIf="pending" class="ai-progress" mode="indeterminate"></mat-progress-bar>
